import { css } from '@emotion/react';

export const root = css`
  width: 100%;
  background: hsl(var(--color-text-1));
  color: hsl(var(--color-grayscale-1));
`;
